import React, { useState } from "react";
import EarthworkPhoto1 from "../../images/services/earthwork.jpg";
import EarthworkPhoto2 from "../../images/services/DSC_2365.jpg";
import EarthworkPhoto3 from "../../images/services/DJI_0103.jpg";
import { FaMapMarkedAlt, FaClock } from "react-icons/fa";
import "./ServiceDetailStyles.css";

function Earthwork() {
  const slides = [EarthworkPhoto1, EarthworkPhoto2, EarthworkPhoto3];
  const [current, setCurrent] = useState(0);

  const nextSlide = () => setCurrent((prev) => (prev + 1) % slides.length);
  const prevSlide = () =>
    setCurrent((prev) => (prev - 1 + slides.length) % slides.length);

  return (
    <>
      <div className="ttm-page-title ttm-bg clearfix">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-12">
              <div className="ttm-page-title-row-inner">
                <div className="page-title-heading">
                  <h2 className="title">Earthwork</h2>
                </div>
                <div className="breadcrumb-wrapper">
                  <span>
                    <a title="Services" href="/services">
                      <i className="fa fa-house" /> &nbsp; Services
                    </a>
                  </span>
                  <span>Earthwork</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* MAIN */}
      <section className="brw-service-detail brw-service-detail--earthwork">
        <div className="container">
          <div className="row brw-service-detail__layout">
            {/* SIDEBAR */}
            <div className="col-lg-4">
              <div className="brw-service-detail__sidebar">
                <h4>Our Services</h4>
                <ul className="brw-service-detail__service-list">
                  <li>
                    <a href="/undergroundUtilities">Underground Utilities</a>
                  </li>
                  <li className="active">
                    <a href="/earthwork">Earthwork</a>
                  </li>
                  <li>
                    <a href="/pavingStriping">Paving & Striping</a>
                  </li>
                  <li>
                    <a href="/roadwayConstruction">Roadway Construction</a>
                  </li>
                  <li>
                    <a href="/segmentedRetainingWalls">
                      Segmented Retaining Walls
                    </a>
                  </li>
                  <li>
                    <a href="/concrete">Concrete</a>
                  </li>
                </ul>

                <div className="brw-service-detail__info-card">
                  <FaMapMarkedAlt />
                  <h5>Service Area</h5>
                  <p>
                    Central Florida & Surrounding Areas
                  </p>
                </div>

                <div className="brw-service-detail__info-card">
                  <FaClock />
                  <h5>Office Hours</h5>
                  <p>
                    Mon–Fri: 8:00 AM – 5:00 PM
                  </p>
                </div>
              </div>
            </div>

            {/* CONTENT */}
            <div className="col-lg-8">
              <div className="brw-service-detail__showcase">
                {/* SLIDER */}
                <div className="brw-service-detail__media">
                  <button
                    className="brw-service-detail__arrow brw-service-detail__arrow--prev"
                    onClick={prevSlide}
                    aria-label="Previous Slide"
                  >
                    ‹
                  </button>
                  <img
                    src={slides[current]}
                    alt="Earthwork Slide"
                    className="brw-service-detail__image"
                  />
                  <button
                    className="brw-service-detail__arrow brw-service-detail__arrow--next"
                    onClick={nextSlide}
                    aria-label="Next Slide"
                  >
                    ›
                  </button>
                </div>

                <h4>Site Preparation Made Easy With Our Earthwork Services</h4>
                <p>
                  With over <strong>20+ years of experience</strong>, BRW
                  Contracting delivers expert land clearing, excavation, and
                  mass grading services. Our GPS-equipped fleet ensures
                  unmatched grading accuracy, increased production efficiency,
                  and strict adherence to project schedules.
                </p>
                <p>
                  From small developments to large-scale commercial sites, our
                  experienced management team brings a forward-thinking approach
                  focused on safety, quality, and long-term performance.
                </p>
                <div className="brw-service-detail__chips">
                  <span>Mass grading</span>
                  <span>Land clearing</span>
                  <span>GPS excavation</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Earthwork;
